import { Component, Injector } from '@angular/core';
import { Validators } from '@angular/forms';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';

/**
 * Create/edit editor for a transaction fee type - the category and calculation behavior
 * (pipeline stage, value kind, and percentage basis) of a kind of fee.
 */
@Component({
    selector: 'app-edittransactionfeetype',
    templateUrl: './edittransactionfeetype.component.html',
    standalone: false
})
export class EdittransactionfeetypeComponent extends ModelEditor {

  constructor(private injector: Injector) {
    super("payments/transactionbreakdown/feetypes", injector);
  }

  public override DefaultModel(): any {
    return {
      Name: "",
      Stage: 100,
      ValueKind: 0,
      Basis: 0
    };
  }

  public override AfterModelLoaded(): void {
  }

  public override BeforeSave(): boolean | void {
  }

  public override Validators(): any {
    return {
      "Name": [Validators.required]
    };
  }
}
